import React from 'react';
import { Navigate } from 'react-router-dom';
import { User } from '../models/user.models';
import { clearHomeScheduleCache } from '../helpers/cache.helpers';

export interface PageProps {
  title: string;
  protected?: boolean;
  children: any;
}

const isSessionExpired = (session: string) => {
  return Date.parse(session) < Date.now();
};

export const Page = (props: PageProps) => {
  // set the document title
  document.title = 'CoeLab | ' + props.title;

  // return if page is not protected
  if (!props.protected) {
    return props.children;
  }

  // grab user
  const user: any = window.localStorage.getItem('user');

  // check if user has a token or session has expired
  if (user) {
    const userContext: User = JSON.parse(user);
    if (userContext.token) {
      if (userContext.expiration && isSessionExpired(userContext.expiration)) {
        window.localStorage.removeItem('user');
        clearHomeScheduleCache();
        return <Navigate to="/login?sessionExpired=true" />;
      }
      return props.children;
    }
  }

  return <Navigate to="/login" />;
};
